var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import VideoElm from './videoElm';
import ConnectionStatus from './connectionStatus';
import MicStatus from './micStatus';
import PinWebcam from './pinWebcam';
const VideoComponent = ({ userId, track }) => {
    const render = () => {
        return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "status", children: [_jsx(ConnectionStatus, { userId: userId }), _jsx(MicStatus, { userId: userId })] }), _jsx("div", { className: "status PinWebcam", children: _jsx(PinWebcam, { userId: userId }) }), _jsx(VideoElm, { track: track })] }));
    };
    return _jsx("div", { className: "camera-modules", children: render() });
};
_react_refresh_temp_1 = VideoComponent;
$RefreshReg$(_react_refresh_temp_1, "VideoComponent");
export default VideoComponent;
